// TEMPORARY: inspector compat moved to snippets/cursor-inspector-compat.liquid
// (inline in theme.liquid <head> for priority). Keep serializeForm mapping below.
// Comment this block back in if you remove the snippet.
/*
(function inspectorCompat() {
  ...
})();
*/

// script for slider new made start
// for home banner — only init when the hero slider exists (avoid Swiper throwing and aborting the rest of this file on PDP, etc.)
(function initHeroBannerSwiper() {
  var heroEls = document.querySelectorAll('[js-image-slider]');
  if (!heroEls.length || typeof Swiper === 'undefined') return;

  heroEls.forEach(function (heroEl) {
    var section = heroEl.closest('.shopify-section');
    if (section && window.getComputedStyle(section).display === 'none') return;

    new Swiper(heroEl, {
      slidesPerView: 1,
      autoHeight: false,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: heroEl.querySelector('.button-next'),
        prevEl: heroEl.querySelector('.button-prev'),
      }
    });
  });
})();


//For Custom Product Template - only init when product slider exists (product pages)
var slider, sliderThumbnail;
(function initProductSlider() {
  var sliderEl = document.querySelector('[js-main-product-slider]');
  var sliderThumbnailEl = document.querySelector('[js-main-product-slider-thumbnail]');
  if (!sliderEl || !sliderThumbnailEl || typeof Swiper === 'undefined') return;
  var sliderWrapper = document.querySelector('.slider-wrapper[data-initial-slide-index]');
  var initialSlide = 0;
  if (sliderWrapper) {
    initialSlide = parseInt(sliderWrapper.getAttribute('data-initial-slide-index'), 10) || 0;
  }
  sliderThumbnail = new Swiper('[js-main-product-slider-thumbnail]', {
    slidesPerView: 5,
    freeMode: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.thumb-button-next',
      prevEl: '.thumb-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 3.35,
        spaceBetween: 8
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      991: {
        slidesPerView: 5,
        spaceBetween: 10
      }
    }
  });
  slider = new Swiper('[js-main-product-slider]', {
    initialSlide: initialSlide,
    autoHeight: true,
    allowTouchMove: true,
    pagination: {
      el: '.custom-product .slider-pagination',
      clickable: true,
      dynamicBullets: true
    },
    thumbs: {
      swiper: sliderThumbnail
    }
  });
  window.customProductSlider = slider;
})();

// PDP gallery without Swiper CDN — lightweight show/hide + thumbnail clicks + swipe
(function initProductGalleryNative() {
  if (typeof Swiper !== 'undefined') return;
  var sliderEl = document.querySelector('[js-main-product-slider]');
  var sliderThumbnailEl = document.querySelector('[js-main-product-slider-thumbnail]');
  if (!sliderEl || !sliderThumbnailEl) return;

  var mainSlides = sliderEl.querySelectorAll('.swiper-slide');
  var thumbSlides = sliderThumbnailEl.querySelectorAll('.swiper-slide');
  if (!mainSlides.length) return;

  var activeIndex = 0;

  function showSlide(index) {
    if (index < 0 || index >= mainSlides.length) return;
    activeIndex = index;
    mainSlides.forEach(function (slide, i) {
      slide.style.display = i === index ? '' : 'none';
      slide.classList.toggle('is-active', i === index);
    });
    thumbSlides.forEach(function (thumb, i) {
      thumb.classList.toggle('swiper-slide-thumb-active', i === index);
    });
    var activeThumb = thumbSlides[index];
    if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  var sliderWrapper = document.querySelector('.slider-wrapper[data-initial-slide-index]');
  var initialSlide = sliderWrapper
    ? parseInt(sliderWrapper.getAttribute('data-initial-slide-index'), 10) || 0
    : 0;
  showSlide(initialSlide);

  thumbSlides.forEach(function (thumb, index) {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', function () {
      showSlide(index);
    });
  });

  var touchStartX = 0;
  sliderEl.addEventListener(
    'touchstart',
    function (event) {
      touchStartX = event.changedTouches[0].screenX;
    },
    { passive: true }
  );
  sliderEl.addEventListener(
    'touchend',
    function (event) {
      var delta = event.changedTouches[0].screenX - touchStartX;
      if (Math.abs(delta) < 40) return;
      showSlide(delta < 0 ? activeIndex + 1 : activeIndex - 1);
    },
    { passive: true }
  );

  window.customProductSlider = {
    slideTo: function (index) {
      showSlide(index);
    }
  };
})();

// product view toggle script


const storageViewType = localStorage.getItem("viewType");
const productGrid = document.querySelector("[js-product_listing__sorted]");
const viewToggleBtn = document.querySelectorAll("[js-view]");

// Collection pages now stay in grid view by default (view toggle removed).
if (productGrid && viewToggleBtn.length === 0) {
  productGrid.classList.remove("product-list_view");
  productGrid.classList.add("product-grid_view");
  localStorage.setItem("viewType", "grid");
}

if (storageViewType == "list" && viewToggleBtn.length > 0) {
  document.querySelector("[js-product_listing__sorted]")?.classList.add("product-list_view");
  document.querySelector("[js-view-list]")?.classList.add("active")
  document.querySelector("[js-view-grid]")?.classList.remove("active")

}

if (productGrid) viewToggleBtn.forEach(btn => {
  btn.addEventListener("click", function (evt) {
    viewToggleBtn.forEach(btn => {
      btn.classList.remove("active")
    })
    if (btn.dataset.view == "grid") {
      viewToggle(productGrid, btn, "grid", this)
    } else {
      viewToggle(productGrid, btn, "list", this)
    }
  })
});

function viewToggle(parent, clickedBtn, viewType, et) {
  if (viewType == 'grid') {
    parent.classList.remove("product-list_view");
    parent.classList.add("product-grid_view");
    et.classList.add("active");
    localStorage.setItem("viewType", viewType);
  } else {
    parent.classList.remove("product-grid_view");
    parent.classList.add("product-list_view");
    clickedBtn.classList.remove("active");
    et.classList.add("active");
    localStorage.setItem("viewType", viewType);
  }
}


// add to cart script
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.getElementById("add-to-cart-btn");
  var minusBtn = document.querySelector("[ao-qty__adjust--minus]");
  var plusBtn = document.querySelector("[ao-qty__adjust--plus]");
  var quantityInput = document.querySelector("[js-quantity_input]");

  if (plusBtn && minusBtn && quantityInput) {
    minusBtn.addEventListener("click", function () {
      var currentQuantity = parseInt(quantityInput.value);
      if (currentQuantity > 1) {
        quantityInput.value = currentQuantity - 1;
      }
    });

    plusBtn.addEventListener("click", function () {
      var currentQuantity = parseInt(quantityInput.value);
      quantityInput.value = currentQuantity + 1;
    });
  }
  if (addToCartButton) {
    addToCartButton.addEventListener("click", function (event) {
      addToCartButton.classList.add("btn--loading")
      event.preventDefault();
      const variantId = event.target.getAttribute("data-variant-id");

      if (variantId) {
        const quantityInput = document.querySelector(".quantity_input");
        const quantity = quantityInput.value || 1;

        fetch(`/cart/add.js?id=${variantId}&quantity=${quantity}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then(response => response.json())
          .then(data => {
            console.log("added");
            window.location.href = "/cart";
            addToCartButton.classList.remove("btn--loading")
          })
          .catch(error => {
            // Handle errors
          });
      }
    });
  }
});

// product form script
class cartModel extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector(".js-close-model");
    this.mainCart = this.querySelector(".js-cart-details");
    this.modelMain = this.querySelector(".js-model-main");

    this.closeBtn.addEventListener("click", this.close.bind(this));

    document.addEventListener("click", (evt) => {
      if (!this.classList.contains("open")) return;
      const isClickInside = this.modelMain.contains(evt.target)

      if (!isClickInside) {
        this.close()
      }
    })

    document.addEventListener("cart-model:build", ({ detail: { key } }) => {
      this.buildCart(key)
    });
    document.addEventListener("cart-model:open", this.open.bind(this));
  };

  open() {
    document.body.classList.add("scroll-lock");
    this.classList.add("open");
  };

  close() {
    document.body.classList.remove("scroll-lock");
    this.classList.remove("open");
  };

  buildCart(key) {
    this.getCartProductMarkup().then((res) => {
      this.cartMarkup(res, key)
    })
  };

  getCartProductMarkup() {
    var url = "/cart?view=ajax";

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(response => response.text())
      .catch(e => console.error(e));
  };

  cartMarkup(text, key) {
    var markup = this._parseProductHTML(text, key);
    var item = markup.item;
    var count = parseInt(item.dataset.count);

    this.updateCount(count);

    // Append item markup
    this.mainCart.innerHTML = item.innerHTML;
  };

  _parseProductHTML(text, cartItemKey) {
    const html = document.createElement('div');
    html.innerHTML = text;

    return {
      item: html.querySelector(`[id="cart-notification-product-${cartItemKey}"]`)
    }
  };

  updateCount(count) {
    var countEls = document.querySelectorAll('.ao-cart-link__bubble-num');

    if (countEls.length) {
      countEls.forEach(el => {
        el.innerText = count;
      });
    }
  }
}

customElements.define('cart-model', cartModel);

// Free gift picker + multi-item cart/add (metafield custom.freegift)
var FreeGiftCart = {
  getPicker: function (root) {
    var scope = root || document;
    return scope.querySelector('[data-free-gift-picker]');
  },

  getSelectedVariantId: function (picker) {
    if (!picker) return null;
    var selected = picker.querySelector('[data-free-gift-variant]:checked');
    if (!selected || !selected.value) return null;
    var id = parseInt(selected.value, 10);
    return isNaN(id) ? null : id;
  },

  getPickerForForm: function (form) {
    if (!form) return null;
    var section =
      form.closest('.custom-product') ||
      form.closest('product-form') ||
      document;
    return this.getPicker(section);
  },

  getLineItemProperties: function (form) {
    var properties = {};
    if (!form) return properties;

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || field.disabled) return;
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
      if (field.value !== '') properties[match[1]] = field.value;
    });

    return properties;
  },

  getMainLineFromForm: function (form) {
    var variantInput =
      form.querySelector('[data-product-select]') || form.querySelector('[name="id"]');
    var quantityInput =
      form.querySelector('.ao-qty__num') || form.querySelector('[name="quantity"]');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var item = { id: variantId, quantity: quantity };
    var props = this.getLineItemProperties(form);

    if (Object.keys(props).length) item.properties = props;

    var sellingPlan = form.querySelector('[name="selling_plan"]:checked');
    if (sellingPlan && !sellingPlan.disabled && sellingPlan.value) {
      item.selling_plan = parseInt(sellingPlan.value, 10);
    }

    return item;
  },

  triggerCartSuccess: function (product) {
    if (typeof theme !== 'undefined' && theme.settings && theme.settings.cartType === 'drawer') {
      if (typeof theme.aoInitCartDrawer === 'function') theme.aoInitCartDrawer();
      document.dispatchEvent(
        new CustomEvent('aoProduct:added', {
          detail: { product: product },
          bubbles: true
        })
      );
      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart-model:build', {
        detail: { key: product.key }
      })
    );
    document.dispatchEvent(new CustomEvent('cart-model:open'));
  },

  getGiftQuantityMode: function (picker) {
    if (picker && picker.dataset.freeGiftQuantityMode === 'fixed') return 'fixed';
    return 'match';
  },

  addWithGift: function (form, giftVariantId) {
    // Kept for compatibility. ComposedCart.buildItems is now the single builder
    // for the atomic /cart/add.js items array — it re-reads the same gift picker
    // (so giftVariantId is implied) and also collects any option-group choices,
    // preserving the exact gift quantity rules (match/fixed) it always had.
    return ComposedCart.add(form);
  },

  addFailedFeedback: function (result) {
    var description = result && result.data && result.data.description;
    alert(description || 'Could not add to cart right now. Please try again in a moment.');
  }
};

// Keeps native free-gift lines consistent with their paid line after cart edits:
// - paid line removed -> gift line removed (customer is never charged for an orphaned gift)
// - paid quantity changed (match mode) -> gift quantity follows, so BOGO discounts
//   always pair off every unit instead of leaving stray paid items
var FreeGiftSync = {
  reconciling: false,
  pending: false,

  paidQuantityFor: function (cart, variantId) {
    return cart.items.reduce(function (sum, item) {
      var props = item.properties || {};
      if (String(item.variant_id) === String(variantId) && props._free_gift !== 'true') {
        return sum + item.quantity;
      }
      return sum;
    }, 0);
  },

  // One shared gift allowance per paid parent variant, across EVERY gift
  // product offered for it (e.g. light OR shelf). The picker is an either/or
  // choice, so a parent never earns more gift units than it has paid units
  // ('match') or one unit in total ('fixed'). Shopify lists the most recently
  // added line first, so the newest choice is kept and older choices are
  // trimmed. Returns a /cart/update.js updates map (line key -> quantity).
  plan: function (cart) {
    var updates = {};
    if (!cart || !cart.items) return updates;
    var groups = {};
    var parents = [];
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (props._free_gift !== 'true') return;
      var parent = props._free_gift_for;
      // A gift line with no parent can never be a valid gift.
      if (!parent) {
        if (item.quantity !== 0) updates[item.key] = 0;
        return;
      }
      parent = String(parent);
      if (!groups[parent]) {
        groups[parent] = [];
        parents.push(parent);
      }
      groups[parent].push(item);
    });

    parents.forEach(function (parent) {
      var lines = groups[parent];
      var paidQuantity = FreeGiftSync.paidQuantityFor(cart, parent);
      var fixed = lines.every(function (line) {
        return (line.properties || {})._free_gift_mode === 'fixed';
      });
      var allowance = paidQuantity <= 0 ? 0 : fixed ? 1 : paidQuantity;
      var total = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
      var wanted = lines.map(function (line) { return line.quantity; });

      if (total > allowance) {
        // Keep the newest choice, trim older ones (never more than the allowance).
        var remaining = allowance;
        for (var i = 0; i < lines.length; i++) {
          wanted[i] = Math.min(lines[i].quantity, remaining);
          remaining -= wanted[i];
        }
      } else if (total < allowance && !fixed) {
        // 'match': gift quantity follows the paid quantity on the newest choice.
        wanted[0] += allowance - total;
      }

      lines.forEach(function (line, index) {
        if (wanted[index] !== line.quantity) updates[line.key] = wanted[index];
      });
    });

    return updates;
  },

  reconcile: function (cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    // A cart edit can land while an update is in flight; queue one trailing
    // pass (with a fresh cart fetch) instead of dropping it.
    if (this.reconciling) {
      this.pending = true;
      return;
    }

    var updates = FreeGiftSync.plan(cart);

    if (!Object.keys(updates).length) return;

    this.reconciling = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (error) {
        console.error('Free gift sync failed', error);
      })
      .then(function () {
        FreeGiftSync.reconciling = false;
        if (FreeGiftSync.pending) {
          FreeGiftSync.pending = false;
          FreeGiftSync.refresh();
        }
      });
  },

  refresh: function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { FreeGiftSync.reconcile(cart); })
      .catch(function () {});
  }
};

document.addEventListener('cart:updated', function (evt) {
  if (evt.detail && evt.detail.cart) FreeGiftSync.reconcile(evt.detail.cart);
});

// Safety pass on page load: catches carts left out of sync by full-page
// removes (the /cart/change?quantity=0 link) or edits from another tab.
document.addEventListener('DOMContentLoaded', function () {
  var bubble = document.querySelector('.ao-cart-link__bubble-num');
  var count = bubble ? parseInt(bubble.textContent, 10) : 0;
  if (!count) return;
  setTimeout(function () {
    FreeGiftSync.refresh();
  }, 1500);
});

// Product option groups (metafield custom.option_groups -> option_group metaobjects).
// Rendered by snippets/option-groups.liquid; selected choices become REAL variant
// lines linked to the main line via _optToken/_optParent/_optGroup/_optFor.
// Mirrors the FreeGiftCart module structure: object literal, data-* hooks only.
var OptionGroups = {
  getContainer: function (root) {
    var scope = root || document;
    return scope.querySelector('[data-option-groups]');
  },

  getContainerForForm: function (form) {
    if (!form) return null;
    var section =
      form.closest('.custom-product') ||
      form.closest('product-form') ||
      document;
    // Pack pages render TWO [data-option-groups] containers (accessory groups
    // above the buy box + the high-beam harness below the pack upgrades), so
    // return the section scope — every consumer only queries [data-og-*]
    // descendants, and this spans both containers.
    return this.getContainer(section) ? section : null;
  },

  hasGroups: function (container) {
    return !!(container && container.querySelector('[data-og-group]'));
  },

  uuid: function () {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    // RFC4122-v4-shaped fallback for older browsers
    var seed = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (seed + Math.random() * 16) % 16 | 0;
      seed = Math.floor(seed / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  },

  // Reads one selection element (radio/checkbox input or dropdown select).
  // Returns { variantId, delta, question, label } or null when nothing is
  // picked. QUESTION choices (data-og-question) carry the label as the value
  // and no variant — they never become cart lines (see ComposedCart).
  readSelectionElement: function (el) {
    var variantId = null;
    var delta = 0;
    var question = false;
    var label = '';
    if (el.tagName === 'SELECT') {
      if (!el.value) return null;
      var option = el.options[el.selectedIndex];
      question = !!(option && option.getAttribute('data-og-question') === 'true');
      if (question) {
        return { variantId: null, delta: 0, question: true, label: el.value };
      }
      variantId = parseInt(el.value, 10);
      delta = option ? parseInt(option.getAttribute('data-og-delta'), 10) || 0 : 0;
    } else {
      if (!el.checked || !el.value) return null;
      question = el.getAttribute('data-og-question') === 'true';
      if (question) {
        return { variantId: null, delta: 0, question: true, label: el.value };
      }
      variantId = parseInt(el.value, 10);
      delta = parseInt(el.getAttribute('data-og-delta'), 10) || 0;
    }
    if (!variantId || isNaN(variantId)) return null;
    return { variantId: variantId, delta: delta, question: false, label: label };
  },

  getSelections: function (container) {
    var selections = [];
    if (!container) return selections;
    container.querySelectorAll('[data-og-group]').forEach(function (group) {
      var handle = group.getAttribute('data-og-handle') || '';
      group.querySelectorAll('[data-og-choice]').forEach(function (el) {
        var selection = OptionGroups.readSelectionElement(el);
        if (selection) {
          selections.push({
            variantId: selection.variantId,
            groupHandle: handle,
            delta: selection.delta,
            question: selection.question,
            label: selection.label
          });
        }
      });
    });
    return selections;
  },

  groupHasSelection: function (group) {
    var elements = group.querySelectorAll('[data-og-choice]');
    for (var i = 0; i < elements.length; i++) {
      if (OptionGroups.readSelectionElement(elements[i])) return true;
    }
    return false;
  },

  // Required groups must have a pick before anything is posted. Toggles the
  // inline error message per group and returns the unmet group elements.
  validateRequired: function (container) {
    var unmet = [];
    if (!container) return unmet;
    container.querySelectorAll('[data-og-group]').forEach(function (group) {
      var error = group.querySelector('[data-og-error]');
      if (group.hasAttribute('data-og-required') && !OptionGroups.groupHasSelection(group)) {
        unmet.push(group);
        group.classList.add('og__group--error');
        if (error) error.hidden = false;
      } else {
        group.classList.remove('og__group--error');
        if (error) error.hidden = true;
      }
    });
    if (unmet.length && typeof unmet[0].scrollIntoView === 'function') {
      unmet[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return unmet;
  }
};

// Single builder for the atomic POST /cart/add.js items array:
//   [ main item (+_optToken when variant options are picked;
//                +_optQ_<group> label properties for question selections),
//     ...option choice child lines (_optParent/_optGroup/_optFor),
//     ...free gift line (_free_gift* — exact pre-existing behaviour) ]
// A product can carry BOTH a free gift and option groups; everything lands in
// one request so the cart never holds a partial configuration.
var ComposedCart = {
  buildItems: function (form) {
    var mainItem = FreeGiftCart.getMainLineFromForm(form);
    if (!mainItem.id || isNaN(mainItem.id)) return null;

    var items = [mainItem];

    var container = OptionGroups.getContainerForForm(form);
    var selections = container ? OptionGroups.getSelections(container) : [];

    // QUESTION selections never create cart lines: the picked label(s) ride
    // on the MAIN item as hidden _optQ_<group-handle> properties (underscore
    // prefix keeps them out of the cart display; staff see them on the order).
    var variantSelections = [];
    var questionGroupHandles = [];
    var questionLabelsByGroup = {};
    selections.forEach(function (selection) {
      if (selection.question) {
        if (!questionLabelsByGroup[selection.groupHandle]) {
          questionLabelsByGroup[selection.groupHandle] = [];
          questionGroupHandles.push(selection.groupHandle);
        }
        questionLabelsByGroup[selection.groupHandle].push(selection.label);
      } else {
        variantSelections.push(selection);
      }
    });

    if (questionGroupHandles.length) {
      mainItem.properties = mainItem.properties || {};
      questionGroupHandles.forEach(function (groupHandle) {
        mainItem.properties['_optQ_' + groupHandle] =
          questionLabelsByGroup[groupHandle].join(', ');
      });
    }

    if (variantSelections.length) {
      var token = OptionGroups.uuid();
      mainItem.properties = mainItem.properties || {};
      mainItem.properties._optToken = token;
      variantSelections.forEach(function (selection) {
        items.push({
          id: selection.variantId,
          // Options are per-unit: children start at the parent quantity and
          // OptionGroupsSync keeps them aligned after later cart edits.
          quantity: mainItem.quantity || 1,
          properties: {
            _optParent: token,
            _optGroup: selection.groupHandle,
            _optFor: String(mainItem.id)
          }
        });
      });
    }

    // The free gift is also shown as the "Free Gift" base of a light option
    // group (data-og-freegift-group). If the customer upgraded that light, drop
    // the free gift so they don't end up with two lights — the upgrade replaces
    // it. Only a real upgrade choice (not the free-gift base) triggers this.
    var giftReplacedByUpgrade = false;
    if (container) {
      container.querySelectorAll('[data-og-freegift-group]').forEach(function (group) {
        var select = group.querySelector('select[data-og-choice]');
        if (select) {
          if (select.value) giftReplacedByUpgrade = true;
          return;
        }
        var picked = group.querySelector('[data-og-choice]:checked');
        if (picked && !picked.hasAttribute('data-og-none') && picked.value) {
          giftReplacedByUpgrade = true;
        }
      });
    }

    // 'match' keeps the gift quantity equal to the paid quantity so
    // buy-1-get-1 automatic discounts pair off every unit (buy 4 = 4 free).
    // 'fixed' always adds a single gift (one-per-order style offers).
    var picker = FreeGiftCart.getPickerForForm(form);
    var giftVariantId = FreeGiftCart.getSelectedVariantId(picker);
    if (giftVariantId && !giftReplacedByUpgrade) {
      var mode = FreeGiftCart.getGiftQuantityMode(picker);
      var giftQuantity = mode === 'fixed' ? 1 : mainItem.quantity || 1;
      items.push({
        id: giftVariantId,
        quantity: giftQuantity,
        properties: {
          _free_gift: 'true',
          _free_gift_for: String(mainItem.id),
          _free_gift_mode: mode
        }
      });
    }

    return items;
  },

  add: function (form) {
    var items = this.buildItems(form);
    if (!items) return Promise.reject(new Error('Missing main variant'));

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(
        function (data) {
          return { ok: response.ok, data: data };
        },
        function () {
          // Challenge/rate-limit pages are not JSON
          return { ok: false, data: { status: response.status } };
        }
      );
    });
  }
};

// Keeps option child lines consistent with their configured parent line after
// cart edits (mirrors FreeGiftSync). Once the app's Cart Transform merge is
// live this becomes a no-op for merged carts — kept as the non-function fallback.
// - parent (_optToken) removed -> all its children removed
// - parent quantity changed -> children follow (options are per-unit)
// - orphan children (missing/bogus _optParent) -> removed
var OptionGroupsSync = {
  reconciling: false,
  pending: false,

  parentFor: function (cart, token) {
    if (!token) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties || {};
      if (props._optToken === token) return cart.items[i];
    }
    return null;
  },

  reconcile: function (cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    // A cart edit can land while an update is in flight; queue one trailing
    // pass (with a fresh cart fetch) instead of dropping it.
    if (this.reconciling) {
      this.pending = true;
      return;
    }

    var updates = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (!props._optParent) return;

      var parent = OptionGroupsSync.parentFor(cart, props._optParent);
      var wanted = parent ? parent.quantity : 0;
      if (wanted !== item.quantity) updates[item.key] = wanted;
    });

    if (!Object.keys(updates).length) return;

    this.reconciling = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (error) {
        console.error('Option groups sync failed', error);
      })
      .then(function () {
        OptionGroupsSync.reconciling = false;
        if (OptionGroupsSync.pending) {
          OptionGroupsSync.pending = false;
          OptionGroupsSync.refresh();
        }
      });
  },

  refresh: function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { OptionGroupsSync.reconcile(cart); })
      .catch(function () {});
  }
};

document.addEventListener('cart:updated', function (evt) {
  if (evt.detail && evt.detail.cart) OptionGroupsSync.reconcile(evt.detail.cart);
});

// Safety pass on page load (mirrors the FreeGiftSync pass, staggered so the
// two modules never post /cart/update.js at the same moment): catches carts
// left out of sync by full-page removes or edits from another tab.
document.addEventListener('DOMContentLoaded', function () {
  var bubble = document.querySelector('.ao-cart-link__bubble-num');
  var count = bubble ? parseInt(bubble.textContent, 10) : 0;
  if (!count) return;
  setTimeout(function () {
    OptionGroupsSync.refresh();
  }, 2400);
});

(function initOptionGroupsUI() {
  if (document.documentElement.dataset.optionGroupsUiInit) return;
  document.documentElement.dataset.optionGroupsUiInit = '1';

  function syncGroup(group) {
    if (!group) return;
    group.querySelectorAll('[data-og-card]').forEach(function (card) {
      var input = card.querySelector('.og__input');
      card.classList.toggle('og__card--selected', !!(input && input.checked));
    });
    // Clear the inline required error as soon as a valid pick lands.
    if (group.hasAttribute('data-og-required') && OptionGroups.groupHasSelection(group)) {
      group.classList.remove('og__group--error');
      var error = group.querySelector('[data-og-error]');
      if (error) error.hidden = true;
    }
  }

  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('[data-og-choice], [data-og-none]')) return;
    syncGroup(input.closest('[data-og-group]'));
  });

  function initAll() {
    document.querySelectorAll('[data-og-group]').forEach(syncGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

(function initFreeGiftPickerUI() {
  if (document.documentElement.dataset.freeGiftPickerUiInit) return;
  document.documentElement.dataset.freeGiftPickerUiInit = '1';

  function syncPicker(picker) {
    if (!picker) return;
    var cards = picker.querySelectorAll('[data-free-gift-card]');
    cards.forEach(function (card) {
      var input = card.querySelector('[data-free-gift-variant]');
      var label = card.querySelector('[data-free-gift-action-label]');
      var btn = card.querySelector('[data-free-gift-select]');
      var selected = !!(input && input.checked);
      card.classList.toggle('free-gift-picker__card--selected', selected);
      card.classList.toggle('free-gift-picker__option--selected', selected);
      if (label) label.textContent = selected ? '✓ Selected' : 'Select';
      if (btn) btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function selectCardInput(card) {
    var input = card.querySelector('[data-free-gift-variant]');
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('[data-free-gift-variant]')) return;
    syncPicker(input.closest('[data-free-gift-picker]'));
  });

  document.addEventListener('click', function (evt) {
    var card = evt.target.closest('[data-free-gift-card]');
    if (!card) return;
    var picker = card.closest('[data-free-gift-picker]');
    if (!picker) return;

    if (evt.target.closest('[data-free-gift-select]')) {
      evt.preventDefault();
    }

    selectCardInput(card);
  });

  function initAll() {
    document.querySelectorAll('[data-free-gift-picker]').forEach(syncPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* ------------------------------------------------------------------ *
 * Dual free gift (light OR shelf) — light-group <-> picker sync
 * ------------------------------------------------------------------ *
 * Bars that offer a CHOICE of free gift (a Night Raiders light OR a Cargo
 * Shelf) render the light group with a hidden "shelf mode": a
 * "No Driving Lights" base + a PAID copy of the light (snippets/option-
 * groups.liquid, [data-og-freegift-dual]). This keeps the light group and
 * the free-gift picker in lock-step:
 *   - keep the free LIGHT (default)   -> picker = light, no light line added
 *   - upgrade or buy the light paid   -> picker auto-switches to SHELF, so the
 *                                        customer keeps a free gift AND pays
 *                                        for the light
 *   - pick the shelf in the picker    -> light group reveals the paid light
 * The gift itself is still added by ComposedCart from the picker, so a dual
 * group is deliberately NOT a data-og-freegift-group (no gift suppression).
 */
(function initFreeGiftDualSync() {
  if (document.documentElement.dataset.freeGiftDualInit) return;
  document.documentElement.dataset.freeGiftDualInit = '1';

  var syncing = false;

  function pickerFor(group) {
    var scope = group.closest('.custom-product') || document;
    return scope.querySelector('[data-free-gift-picker]');
  }

  function norm(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : String(n);
  }

  function pickerGiftId(picker) {
    var sel = picker && picker.querySelector('[data-free-gift-variant]:checked');
    return sel ? norm(sel.value) : null;
  }

  function setPicker(picker, variantId) {
    if (!picker || !variantId) return;
    var target = norm(variantId);
    picker.querySelectorAll('[data-free-gift-variant]').forEach(function (r) {
      if (norm(r.value) === target && !r.checked) {
        r.checked = true;
        // Fires the picker's own UI sync; our picker listener is guarded below.
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // 'light' when the free-light base is picked; 'shelf' for anything else
  // (the "No Driving Lights" base, the paid light, or a paid upgrade).
  function checkedGift(group) {
    var checked = group.querySelector('input:checked');
    if (!checked) return null;
    var row = checked.closest('[data-fg-row]');
    if (row && row.getAttribute('data-fg-row') === 'light-base') return 'light';
    return 'shelf';
  }

  function setVisibility(group, mode) {
    group.querySelectorAll('[data-fg-row]').forEach(function (row) {
      var rowMode = row.getAttribute('data-fg-row') === 'light-base' ? 'light' : 'shelf';
      var visible = rowMode === mode;
      row.style.display = visible ? '' : 'none';
      if (!visible) {
        var input = row.querySelector('input');
        if (input) input.checked = false; // never leave a hidden row selected
      }
    });
  }

  function ensureChecked(group, mode) {
    if (group.querySelector('input:checked')) return;
    var sel = mode === 'light'
      ? '[data-fg-row="light-base"] input'
      : '[data-fg-row="shelf-base"] input';
    var input = group.querySelector(sel);
    if (input) input.checked = true;
  }

  function shelfIdFor(group, picker) {
    var lightId = norm(group.getAttribute('data-og-freegift-light'));
    var shelfId = null;
    if (picker) {
      picker.querySelectorAll('[data-free-gift-variant]').forEach(function (r) {
        if (norm(r.value) !== lightId) shelfId = r.value;
      });
    }
    return shelfId;
  }

  // Picker changed (or first load) -> put the light group in the matching mode.
  function fromPicker(group, picker) {
    var lightId = norm(group.getAttribute('data-og-freegift-light'));
    var mode = pickerGiftId(picker) === lightId ? 'light' : 'shelf';
    syncing = true;
    setVisibility(group, mode);
    if (mode === 'light') {
      // Free light is the gift: force the free-light base (drop any paid light).
      var base = group.querySelector('[data-fg-row="light-base"] input');
      if (base) base.checked = true;
    } else {
      ensureChecked(group, 'shelf');
    }
    group.dispatchEvent(new Event('change', { bubbles: true })); // LivePriceTotal
    syncing = false;
  }

  // Light group changed -> reflect the resulting free gift on the picker.
  function fromLightGroup(group, picker) {
    var gift = checkedGift(group);
    if (!gift) return;
    var lightId = group.getAttribute('data-og-freegift-light');
    syncing = true;
    setPicker(picker, gift === 'light' ? lightId : shelfIdFor(group, picker));
    setVisibility(group, gift === 'light' ? 'light' : 'shelf');
    if (gift !== 'light') ensureChecked(group, 'shelf');
    group.dispatchEvent(new Event('change', { bubbles: true }));
    syncing = false;
  }

  function wire(group) {
    var picker = pickerFor(group);
    if (!picker) return;
    group.addEventListener('change', function () {
      if (syncing) return;
      fromLightGroup(group, picker);
    });
    picker.addEventListener('change', function (e) {
      if (syncing) return;
      if (!e.target.matches || !e.target.matches('[data-free-gift-variant]')) return;
      fromPicker(group, picker);
    });
    fromPicker(group, picker); // initial state from the picker default (light)
  }

  function initAll() {
    document.querySelectorAll('[data-og-freegift-dual]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

(function initFreeGiftCartInterceptors() {
  if (document.documentElement.dataset.freeGiftCartInit) return;
  document.documentElement.dataset.freeGiftCartInit = '1';

  var handling = false;

  function getAddButton(form) {
    return (
      form.querySelector('[data-add-to-cart]') ||
      form.querySelector('.gPreorderBtn') ||
      (form.closest('product-form') &&
        form.closest('product-form').querySelector('[data-add-to-cart], .gPreorderBtn'))
    );
  }

  // Intercept when a free gift is selected (original behaviour) OR the product
  // carries option groups — both need the composed multi-item /cart/add.js.
  function shouldHandle(form) {
    if (!form || !form.getAttribute('action')) return false;
    if (form.getAttribute('action').indexOf('/cart/add') === -1) return false;
    var picker = FreeGiftCart.getPickerForForm(form);
    if (FreeGiftCart.getSelectedVariantId(picker)) return true;
    return OptionGroups.hasGroups(OptionGroups.getContainerForForm(form));
  }

  function runComposedAdd(form, evt) {
    // A second submit while the first add is in flight must be swallowed,
    // not allowed to fall through to other submit handlers — otherwise a
    // double-click silently doubles the paid + gift/option quantities.
    if (handling) {
      if (evt && shouldHandle(form)) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }
      return false;
    }
    if (!shouldHandle(form)) return false;

    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    }

    // Required option groups block the add with an inline error, no POST.
    var unmet = OptionGroups.validateRequired(OptionGroups.getContainerForForm(form));
    if (unmet.length) return true;

    handling = true;
    var btn = getAddButton(form);
    if (btn) btn.classList.add('btn--loading');

    ComposedCart.add(form)
      .then(function (result) {
        if (result.data.status === 422 || !result.ok) {
          console.warn('Composed cart add failed', result.data);
          FreeGiftCart.addFailedFeedback(result);
          return;
        }

        var product =
          result.data.items && result.data.items.length
            ? result.data.items[0]
            : result.data;
        FreeGiftCart.triggerCartSuccess(product);
      })
      .catch(function (error) {
        console.error(error);
        FreeGiftCart.addFailedFeedback(null);
      })
      .finally(function () {
        handling = false;
        if (btn) btn.classList.remove('btn--loading');
      });

    return true;
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (form && form.tagName === 'FORM') runComposedAdd(form, evt);
    },
    true
  );

  // Globo Pre-order button path — collects option selections and the free
  // gift exactly like the normal add-to-cart submit.
  document.addEventListener(
    'click',
    function (evt) {
      if (handling) return;
      var btn = evt.target.closest('.gPreorderBtn');
      if (!btn) return;

      var form =
        btn.closest('form[action*="/cart/add"]') ||
        (btn.closest('product-form') &&
          btn.closest('product-form').querySelector('form[action*="/cart/add"]'));
      if (!form) return;

      runComposedAdd(form, evt);
    },
    true
  );
})();

class productForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".ao-product-single__form");
    this.addToCart = this.querySelector("[data-add-to-cart]");

    if (this.form) {
      this.form.addEventListener('submit', this.addItemFromForm.bind(this));
    }
    this.initVariantSelection();
  }

  initVariantSelection() {
    var variantSelect = this.querySelector('[data-product-select]');
    var variantInputs = this.querySelectorAll('[data-ao-variant-input]');
    var variantsScript = this.querySelector('[data-variants-json]');
    if (!variantSelect || !variantsScript) return;
    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (e) {
      return;
    }
    var self = this;
    function getCurrentOptions() {
      var result = [];
      variantInputs.forEach(function (el) {
        if (el.checked || (el.tagName === 'SELECT' && el.value)) {
          result.push({
            value: el.value || (el.options[el.selectedIndex] && el.options[el.selectedIndex].value),
            index: el.dataset.index
          });
        }
      });
      return result;
    }
    function findVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (opt) {
          return variant[opt.index] === opt.value;
        });
      }) || null;
    }
    function updateVariantImage(variant) {
      if (!variant || !variant.featured_media || !window.customProductSlider) return;
      var slide = document.querySelector('.slider-wrapper .swiper-slide[data-media-id="' + variant.featured_media.id + '"]');
      if (!slide) return;
      var slides = slide.closest('.swiper-wrapper');
      if (!slides) return;
      var index = Array.prototype.indexOf.call(slides.children, slide);
      if (index >= 0) window.customProductSlider.slideTo(index);
    }
    function formatMoney(cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
      var n = (cents / 100).toFixed(2);
      return '$' + parseFloat(n).toLocaleString('en-AU', { minimumFractionDigits: 2 });
    }
    function updateUi(variant) {
      if (!variant) return;
      variantSelect.value = variant.id;
      if (self.addToCart) {
        self.addToCart.disabled = !variant.available;
        var span = self.addToCart.querySelector('span');
        if (span) {
          var productId = self.dataset.productId;
          var inventory =
            window.inventories &&
            productId &&
            window.inventories[productId] &&
            window.inventories[productId][variant.id]
              ? window.inventories[productId][variant.id]
              : null;
          var isPreorder =
            self.addToCart.classList.contains('gPreorderBtn') ||
            (inventory &&
              inventory.policy === 'continue' &&
              (parseInt(inventory.quantity, 10) || 0) <= 0);
          if (!variant.available) {
            span.textContent = 'sold out';
          } else if (!isPreorder && inventory) {
            span.textContent = 'Add to cart';
          } else if (isPreorder && typeof window.refreshPreorderButtonLabels !== 'function') {
            span.textContent = 'Pre Order';
          }
          if (variant.available && typeof window.refreshPreorderButtonLabels === 'function') {
            window.refreshPreorderButtonLabels();
          }
        }
      }
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl && variant.price !== undefined) {
        priceEl.textContent = formatMoney(variant.price);
      }
      var compareEl = document.querySelector('[data-compare-price]');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var saveEl = document.querySelector('[data-ao-save-price]');
      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var savings = variant.compare_at_price - variant.price;
          saveEl.textContent = saveEl.textContent.replace(/\$[\d,.-]+/, formatMoney(savings));
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      var skuEl = document.querySelector('[data-sku]');
      if (skuEl && variant.sku !== undefined) {
        skuEl.textContent = variant.sku || '';
      }
      if (window.updatePayPalPayLaterAmount) {
        window.updatePayPalPayLaterAmount(variant.price);
      }
      if (window.currentProductVariant) window.currentProductVariant = variant;
      updateVariantImage(variant);
      if (window.refreshPreorderButtonLabels) {
        window.refreshPreorderButtonLabels();
      }
    }
    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var options = getCurrentOptions();
        var variant = findVariant(options);
        updateUi(variant);
      });
    });
    var initialOptions = getCurrentOptions();
    if (initialOptions.length > 0) {
      var v = findVariant(initialOptions) || variants[0];
      updateUi(v);
    } else if (variants.length > 0) {
      updateUi(variants[0]);
    }
  }

  serializeForm(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      // inspectorCompat renames the variant select; map it back for /cart/add
      var fieldName = field.name === 'inspector-id' ? 'id' : field.name;
      arr.push(
        encodeURIComponent(fieldName) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }

  addItemFromForm(evt) {
    evt.preventDefault();

    if (!this.form || !this.addToCart) return;
    if (this._adding) return;
    this._adding = true;
    var releaseAdding = function () { this._adding = false; }.bind(this);

    var giftVariantId = FreeGiftCart.getSelectedVariantId(
      FreeGiftCart.getPickerForForm(this.form)
    );
    var ogContainer = OptionGroups.getContainerForForm(this.form);
    var hasOptionGroups = OptionGroups.hasGroups(ogContainer);

    if (giftVariantId || hasOptionGroups) {
      // Required option groups block the add with an inline error, no POST.
      if (OptionGroups.validateRequired(ogContainer).length) {
        releaseAdding();
        return;
      }

      this.addToCart.classList.add('btn--loading');
      ComposedCart.add(this.form)
        .then(function (result) {
          if (result.data.status === 422 || !result.ok) {
            console.warn('Composed cart add failed', result.data);
            FreeGiftCart.addFailedFeedback(result);
            return;
          }
          var product =
            result.data.items && result.data.items.length
              ? result.data.items[0]
              : result.data;
          this.success(product);
        }.bind(this))
        .catch(function (error) {
          console.error(error);
          FreeGiftCart.addFailedFeedback(null);
        })
        .finally(function () {
          this.addToCart.classList.remove('btn--loading');
          releaseAdding();
        }.bind(this));
      return;
    }

    this.addToCart.classList.add('btn--loading');

    var data = this.serializeForm(this.form);

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .then(function (data) {
        if (data.status === 422) {
          FreeGiftCart.addFailedFeedback({ data: data });
        } else {
          var product = data;
          this.success(product);
        }

        this.addToCart.classList.remove('btn--loading');
        releaseAdding();
      }.bind(this))
      .catch(function (error) {
        // Without this, a challenge/rate-limit response leaves the button
        // spinning forever and the customer gets no feedback at all.
        console.error(error);
        this.addToCart.classList.remove('btn--loading');
        FreeGiftCart.addFailedFeedback(null);
        releaseAdding();
      }.bind(this));
  };

  success(product) {
    FreeGiftCart.triggerCartSuccess(product);
  };
}

customElements.define('product-form', productForm);

class productQuantity extends HTMLElement {
  constructor() {
    super();

    this.plus = this.querySelector('.ao-qty__adjust--plus');
    this.minus = this.querySelector('.ao-qty__adjust--minus');
    this.input = this.querySelector('.ao-qty__num');
    this.productQty = document.querySelector('[data-product-quantity]');

    this.plus.addEventListener('click', function () {
      var qty = this._getQty();
      this._change(qty + 1);
    }.bind(this));

    this.minus.addEventListener('click', function () {
      var qty = this._getQty();
      this._change(qty - 1);
    }.bind(this));

    this.input.addEventListener('change', function (evt) {
      this._change(this._getQty());
    }.bind(this));
  };

  _getQty() {
    var qty = this.input.value;
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty);
  };

  _change(qty) {
    if (qty <= 1) {
      qty = 1;
    }

    this.input.value = qty;
    this.productQty.value = qty;
  }
}

customElements.define('product-quantity', productQuantity);

/* ------------------------------------------------------------------ *
 * Mobile sticky add-to-cart (PDP)
 * ------------------------------------------------------------------ */
(function initMobileStickyAtc() {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (/([?&]width=)\d+/.test(url)) {
      return url.replace(/([?&]width=)\d+/, '$1' + width);
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  ready(function () {
    var sticky = document.querySelector('[data-mobile-sticky-atc]');
    if (!sticky) return;

    var container = sticky.closest('.qty-with-btn') || document;
    var form = container.querySelector('form[action*="/cart/add"]');
    var mainButton = container.querySelector('[data-add-to-cart]');
    var stickyButton = sticky.querySelector('[data-mobile-sticky-submit]');
    var stickyLabel = sticky.querySelector('[data-mobile-sticky-label]');
    var stickyPrice = sticky.querySelector('[data-mobile-sticky-price]');
    var stickyTitle = sticky.querySelector('[data-mobile-sticky-title]');
    var stickyImage = sticky.querySelector('[data-mobile-sticky-image]');
    var variantSelect = form ? form.querySelector('[data-product-select]') : null;
    var qtyInput = form ? form.querySelector('[data-product-quantity]') : null;
    var priceEl = document.querySelector('[data-product-price]');
    var titleEl = document.querySelector('.product-title');
    var triggerEl = container.querySelector('.qty-with-add-btn') || mainButton;

    if (!form || !mainButton || !stickyButton) return;

    var variants = {};
    var variantScript = container.querySelector('[data-variants-json]');
    if (variantScript) {
      try {
        (JSON.parse(variantScript.textContent || '[]') || []).forEach(function (variant) {
          variants[String(variant.id)] = variant;
        });
      } catch (e) {
        // keep empty variants map
      }
    }

    function parseMoneyToCents(text) {
      var cleaned = String(text || '').replace(/[^0-9,.-]/g, '');
      if (!cleaned) return NaN;
      if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
        cleaned = cleaned.replace(/,/g, '');
      } else if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1) {
        cleaned = cleaned.replace(/,/g, '.');
      }
      var amount = parseFloat(cleaned);
      if (!isFinite(amount)) return NaN;
      return Math.round(amount * 100);
    }

    function formatMoney(cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
      return '$' + (cents / 100).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function getVariantImageUrl() {
      if (!variantSelect) return '';
      var variant = variants[String(variantSelect.value)];
      if (!variant) return '';
      var src =
        (variant.featured_image && variant.featured_image.src) ||
        (variant.featured_media &&
          variant.featured_media.preview_image &&
          variant.featured_media.preview_image.src) ||
        '';
      return withWidth(src, 180);
    }

    function syncTitle() {
      if (!stickyTitle || !titleEl) return;
      stickyTitle.textContent = titleEl.textContent.trim();
    }

    function syncPrice() {
      if (!stickyPrice || !priceEl) return;
      var priceText = priceEl.textContent.trim();
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!isFinite(qty) || qty < 1) qty = 1;
      var unitCents = parseMoneyToCents(priceText);
      if (isFinite(unitCents)) {
        stickyPrice.textContent = formatMoney(unitCents * qty);
      } else {
        stickyPrice.textContent = priceText;
      }
    }

    function syncImage() {
      if (!stickyImage) return;
      var variantImage = getVariantImageUrl();
      if (variantImage) {
        stickyImage.src = variantImage;
      }
    }

    function getMainPreorderEta() {
      var anchor = mainButton.closest('.add-btn-eta-anchor');
      if (!anchor || !anchor.classList.contains('add-btn-eta-anchor--active')) return '';
      var etaBadge = anchor.querySelector('[data-preorder-eta-badge]');
      return etaBadge ? etaBadge.textContent.trim() : '';
    }

    function syncButton() {
      var mainLabel = mainButton.querySelector('span');
      var labelText = mainLabel ? mainLabel.textContent.trim() : (mainButton.disabled ? 'Sold out' : 'Add to cart');
      stickyButton.disabled = !!mainButton.disabled;
      if (stickyLabel) stickyLabel.textContent = labelText || 'Add to cart';

      var etaText = getMainPreorderEta();
      var stickyEta = stickyButton.querySelector('[data-mobile-sticky-eta]');
      if (etaText) {
        if (!stickyEta) {
          stickyEta = document.createElement('span');
          stickyEta.className = 'mobile-sticky-atc__eta';
          stickyEta.setAttribute('data-mobile-sticky-eta', '');
          stickyButton.appendChild(stickyEta);
        }
        if (stickyEta.textContent !== etaText) {
          stickyEta.textContent = etaText;
        }
        stickyButton.classList.add('has-preorder-eta');
      } else {
        if (stickyEta) stickyEta.remove();
        stickyButton.classList.remove('has-preorder-eta');
      }
    }

    function syncAll() {
      syncTitle();
      syncPrice();
      syncImage();
      syncButton();
    }

    function updateStickyVisibility() {
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      if (!mobile || !triggerEl) {
        sticky.classList.remove('is-visible');
        return;
      }
      var rect = triggerEl.getBoundingClientRect();
      // Show after ~50% of the native add-to-cart row has passed the top.
      var threshold = rect.height * 0.5;
      var hasPassedNativeAtc = rect.bottom <= threshold;
      sticky.classList.toggle('is-visible', hasPassedNativeAtc);
    }

    var visibilityRaf = null;
    function queueVisibilityUpdate() {
      if (visibilityRaf) return;
      visibilityRaf = requestAnimationFrame(function () {
        visibilityRaf = null;
        updateStickyVisibility();
      });
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled || mainButton.disabled) return;
      mainButton.click();
    });

    form.addEventListener('change', syncAll);
    document.addEventListener('variant:change', syncAll);
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);

    if (priceEl && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncPrice).observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      var mainLabel = mainButton.querySelector('span');
      var buttonObserver = new MutationObserver(syncButton);
      buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
      if (mainLabel) {
        buttonObserver.observe(mainLabel, { childList: true, characterData: true, subtree: true });
      }

      // ETA badge is a sibling outside the main button (Globo-safe), so watch the wrap too.
      var atcWrap = container.querySelector('.add-btn-wrap') || mainButton.parentElement;
      if (atcWrap) {
        buttonObserver.observe(atcWrap, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    syncAll();
    queueVisibilityUpdate();
  });
})();

/* ------------------------------------------------------------------ *
 * Shopify Inbox + mobile sticky ATC compatibility
 * Hide the chat launcher while sticky ATC is showing so Add to cart
 * stays tappable. If chat is already open, leave the panel visible.
 * ------------------------------------------------------------------ */
(function initShopifyInboxStickyCompat() {
  var host = null;
  var sticky = null;
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var hostObserver = null;
  var hostSelector = 'shopify-chat, shopify-agent, inbox-online-store-chat#ShopifyChat, #shopify-chat inbox-online-store-chat, #ShopifyChat';

  function getHost() {
    return (
      document.querySelector('shopify-chat') ||
      document.querySelector('shopify-agent') ||
      document.querySelector('inbox-online-store-chat#ShopifyChat') ||
      document.querySelector('#shopify-chat inbox-online-store-chat') ||
      document.querySelector('#ShopifyChat')
    );
  }

  function isAgentHost(host) {
    if (!host) return false;
    var tag = host.tagName;
    return tag === 'SHOPIFY-CHAT' || tag === 'SHOPIFY-AGENT';
  }

  function isChatOpen(host) {
    if (!host) return false;
    if (isAgentHost(host)) {
      if (host.hasAttribute('open')) return true;
      if (host.getAttribute('aria-expanded') === 'true') return true;
      var view = host.getAttribute('view');
      if (view && view !== 'chat' && view !== 'launcher' && view !== 'minimized') {
        return true;
      }
      return false;
    }
    var value = host.getAttribute('is-open');
    return value === 'true' || value === '';
  }

  function clearLegacySizeHacks(host) {
    // New Shopify Agent widget — do not rewrite its layout.
    if (isAgentHost(host)) return;

    // Always undo hide hacks that blocked closing the chat.
    ['opacity', 'visibility', 'pointer-events'].forEach(function (prop) {
      if (host.style.getPropertyValue(prop)) host.style.removeProperty(prop);
    });

    // Only strip the old 45px launcher clamp while closed. When open, Shopify
    // sizes the host for the panel — do not touch those dimensions.
    if (isChatOpen(host)) return;

    var clamped =
      host.style.width === '45px' ||
      host.style.height === '45px' ||
      host.style.maxWidth === '45px' ||
      host.style.maxHeight === '45px';

    if (!clamped) return;

    [
      'width',
      'height',
      'min-width',
      'min-height',
      'max-width',
      'max-height'
    ].forEach(function (prop) {
      if (host.style.getPropertyValue(prop)) host.style.removeProperty(prop);
    });

    var button = host.shadowRoot && host.shadowRoot.querySelector('button.chat-toggle');
    if (!button) return;

    [
      'width',
      'height',
      'min-width',
      'min-height',
      'max-width',
      'max-height',
      'border',
      'border-radius',
      'margin',
      'display'
    ].forEach(function (prop) {
      if (button.style.getPropertyValue(prop)) button.style.removeProperty(prop);
    });
  }

  function setRootClass(name, enabled) {
    var classes = document.documentElement.classList;
    if (classes.contains(name) !== enabled) classes.toggle(name, enabled);
  }

  function syncStickyInboxOffset() {
    var stickyVisible = !!(
      sticky &&
      sticky.isConnected &&
      mobileQuery.matches &&
      sticky.classList.contains('is-visible')
    );

    setRootClass('aor-sticky-atc-visible', stickyVisible);
  }

  function sync() {
    if (host) {
      clearLegacySizeHacks(host);
    }

    var open = !!(host && isChatOpen(host));
    setRootClass('aor-shopify-chat-open', open);
    syncStickyInboxOffset();
  }

  function observeHost(nextHost) {
    if (hostObserver) hostObserver.disconnect();
    host = nextHost;
    if (host && typeof MutationObserver !== 'undefined') {
      hostObserver = new MutationObserver(sync);
      hostObserver.observe(host, {
        attributes: true,
        attributeFilter: ['is-open', 'open', 'view', 'aria-expanded', 'class', 'style']
      });
    }
    sync();
  }

  function findAddedHost(mutations, selector) {
    selector = selector || hostSelector;
    for (var i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        var node = added[j];
        if (node.nodeType !== 1 || !node.isConnected) continue;
        if (node.matches(selector)) return node;
        var nestedHost = node.querySelector(selector);
        if (nestedHost) return nestedHost;
      }
    }
    return null;
  }

  function init() {
    sticky = document.querySelector('[data-mobile-sticky-atc]');
    observeHost(getHost());

    window.addEventListener('resize', sync);
    var scrollQueued = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollQueued) return;
        scrollQueued = true;
        requestAnimationFrame(function () {
          scrollQueued = false;
          syncStickyInboxOffset();
        });
      },
      { passive: true }
    );

    if (typeof MutationObserver === 'undefined') return;

    if (sticky) {
      new MutationObserver(syncStickyInboxOffset).observe(sticky, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    var mountObserver = new MutationObserver(function (mutations) {
      // Reviews, price updates and image loaders also change the page. Once
      // preferred chat is mounted those mutations need no selectors or writes.
      if (host && host.isConnected) {
        if (host.tagName === 'SHOPIFY-CHAT') return;
        // Older providers can mount a fallback container before their newer
        // custom element. Inspect only added subtrees for that upgrade; retain
        // getHost's original preference if several providers coexist.
        var preferredSelector = host.tagName === 'SHOPIFY-AGENT'
          ? 'shopify-chat'
          : 'shopify-chat, shopify-agent';
        if (host.tagName !== 'SHOPIFY-AGENT' && host.tagName !== 'INBOX-ONLINE-STORE-CHAT') {
          preferredSelector += ', inbox-online-store-chat';
        } else if (host.tagName === 'INBOX-ONLINE-STORE-CHAT' && host.id !== 'ShopifyChat') {
          preferredSelector += ', inbox-online-store-chat#ShopifyChat';
        }
        if (findAddedHost(mutations, preferredSelector)) observeHost(getHost());
        return;
      }
      if (host) {
        // A provider may replace its custom element. Rebind once on removal,
        // including a replacement that was already inserted in this batch.
        observeHost(getHost());
        if (host) return;
      }
      var addedHost = findAddedHost(mutations);
      if (addedHost) observeHost(getHost());
    });

    mountObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Removing the promotion text from the product page after end of given date
const proEndDateSelector = document.querySelector('[js-promo-enddate]');
const promoMessage = document.querySelector('[js-promo-message]');
if (proEndDateSelector && promoMessage) {
  const endDateInTime = proEndDateSelector.getAttribute('data-promo-enddate');
  if (endDateInTime) {
    const endPromoTime = new Date(endDateInTime).getTime();
    const currentTime = new Date().getTime();
    promoMessage.style.display = endPromoTime > currentTime ? 'block' : 'none';
  }
}

// PDP discount urgency timer (end of month or block end_datetime)
(function initDiscountUrgencyTimers() {
  var roots = document.querySelectorAll('[js-discount-urgency]');
  if (!roots.length) return;

  function getEndOfMonthMs(timeZone) {
    try {
      var now = new Date();
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
      }).formatToParts(now);
      var y = parseInt(
        parts.find(function (p) {
          return p.type === 'year';
        }).value,
        10
      );
      var m = parseInt(
        parts.find(function (p) {
          return p.type === 'month';
        }).value,
        10
      );
      var lastDay = new Date(y, m, 0).getDate();
      var iso =
        y +
        '-' +
        String(m).padStart(2, '0') +
        '-' +
        String(lastDay).padStart(2, '0') +
        'T23:59:59';
      var parsed = new Date(iso);
      if (!isNaN(parsed.getTime())) return parsed.getTime();
    } catch (e) {
      /* fall through */
    }
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59, 999).getTime();
  }

  function parseDeadline(el) {
    var endAttr = el.getAttribute('data-end');
    if (endAttr) {
      var t = new Date(endAttr).getTime();
      if (!isNaN(t)) return t;
    }
    if (el.getAttribute('data-end-of-month') === 'true') {
      return getEndOfMonthMs(el.getAttribute('data-timezone') || 'Australia/Sydney');
    }
    return null;
  }

  function formatRemaining(ms) {
    if (ms <= 0) return null;
    var days = Math.floor(ms / 86400000);
    var hours = Math.floor((ms % 86400000) / 3600000);
    if (days >= 1) {
      return days === 1 ? 'only 1 day left' : 'only ' + days + ' days left';
    }
    if (hours >= 1) {
      return hours === 1 ? 'only 1 hour left' : 'only ' + hours + ' hours left';
    }
    var mins = Math.floor((ms % 3600000) / 60000);
    if (mins >= 1) {
      return mins === 1 ? 'only 1 minute left' : 'only ' + mins + ' minutes left';
    }
    return 'less than 1 minute left';
  }

  roots.forEach(function (root) {
    var countdownEl = root.querySelector('[js-discount-urgency-countdown]');
    if (!countdownEl) return;
    var deadline = parseDeadline(root);
    if (deadline == null || isNaN(deadline)) return;

    function tick() {
      var remaining = deadline - Date.now();
      var suffix = formatRemaining(remaining);
      if (!suffix) {
        root.style.display = 'none';
        return;
      }
      countdownEl.textContent = ' \u2014 ' + suffix;
    }

    tick();
    setInterval(tick, 1000);
  });
})();

// for product list slider section — init every section instance; scope nav to each container
(function initProductListSliderSection() {
  var attempts = 0;
  var maxAttempts = 40;

  function boot() {
    var plsEls = document.querySelectorAll('[js-hb-pls]');
    if (!plsEls.length) return;

    if (typeof Swiper === 'undefined') {
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(boot, 50);
      }
      return;
    }

    var opts = {
      // Keep mobile consistent even on very small devices (<360px).
      slidesPerView: 2,
      spaceBetween: 6,
      loop: true,
      watchOverflow: true,
      breakpoints: {
        360: {
          slidesPerView: 2,
          spaceBetween: 6,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1360: {
          slidesPerView: 4,
        },
      },
    };
    window.productListSliders = [];
    plsEls.forEach(function (plsEl) {
      if (plsEl.classList.contains('swiper-initialized')) return;
      var nextEl = plsEl.querySelector('.button-next');
      var prevEl = plsEl.querySelector('.button-prev');
      var swiper = new Swiper(
        plsEl,
        Object.assign({}, opts, {
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        })
      );
      window.productListSliders.push(swiper);
    });
    window.productListSlider = window.productListSliders[0];
  }

  boot();
})();

// Similar products slider (PDP, below description) — 3.5 visible on mobile
(function initSimilarProductsSlider() {
  var attempts = 0;
  var maxAttempts = 40;

  function boot() {
    var els = document.querySelectorAll('[js-similar-products-slider]');
    if (!els.length) return;

    if (typeof Swiper === 'undefined') {
      attempts += 1;
      if (attempts < maxAttempts) setTimeout(boot, 50);
      return;
    }

    els.forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;
      var observer = null;

      function initialize() {
        if (observer) observer.disconnect();
        el.removeEventListener('pointerdown', initialize);
        el.removeEventListener('focusin', initialize);
        if (el.classList.contains('swiper-initialized')) return;
        var nextEl = el.querySelector('.hb-button-next');
        var prevEl = el.querySelector('.hb-button-prev');
        new Swiper(el, {
          slidesPerView: 3.5,
          spaceBetween: 8,
          watchOverflow: true,
          navigation:
            nextEl && prevEl
              ? {
                  nextEl: nextEl,
                  prevEl: prevEl,
                }
              : false,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            991: {
              slidesPerView: 4,
              spaceBetween: 12,
            },
            1360: {
              slidesPerView: 5,
              spaceBetween: 14,
            },
          },
        });
      }

      // Keep SSR cards intact; initialize distant sliders as they approach view.
      if (typeof IntersectionObserver === 'undefined') {
        initialize();
        return;
      }
      var nearViewport = true;
      try {
        var bounds = el.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        nearViewport = bounds.top <= viewportHeight + 600 && bounds.bottom >= -600;
      } catch (error) {}
      if (nearViewport) {
        initialize();
        return;
      }
      try {
        el.addEventListener('pointerdown', initialize, { passive: true });
        el.addEventListener('focusin', initialize);
        observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) initialize();
        }, { rootMargin: '600px 0px' });
        observer.observe(el);
      } catch (error) {
        initialize();
      }
    });
  }

  boot();
})();

// Product metafield video: muted autoplay; click or Enter/Space toggles sound.
// Must run before product-recommendations define below (theme.js already registers that element).
(function initProductMetafieldVideo() {
  function loadViewportVideo(video) {
    if (video.dataset.viewportVideoLoaded === 'true') return;
    var sources = Array.from(video.querySelectorAll('source[data-src]'));
    sources.sort(function (a, b) { return Number(a.dataset.width || 0) - Number(b.dataset.width || 0); });
    var requiredWidth = video.clientWidth * (window.devicePixelRatio || 1);
    var source = sources.find(function (item) { return Number(item.dataset.width) >= requiredWidth; }) || sources[sources.length - 1];
    if (!source) return;
    video.dataset.viewportVideoLoaded = 'true';
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
    video.load();
    video.play().catch(function () {});
  }

  function toggleSound(wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    loadViewportVideo(video);
    video.muted = !video.muted;
    if (!video.muted) {
      video.play().catch(function () {});
    }

    wrapper.classList.toggle('is-unmuted', !video.muted);
    var hint = wrapper.querySelector('[data-product-metafield-video-hint]');
    if (hint) {
      hint.classList.toggle('is-muted', video.muted);
      hint.classList.toggle('is-unmuted', !video.muted);
      hint.setAttribute(
        'aria-label',
        video.muted ? 'Turn sound on' : 'Mute video'
      );
    }
    wrapper.setAttribute(
      'aria-label',
      video.muted ? 'Product video. Tap to turn sound on.' : 'Product video. Tap to mute.'
    );
  }

  function bindProductMetafieldVideo(wrapper) {
    if (wrapper.dataset.metafieldVideoBound === 'true') return;
    wrapper.dataset.metafieldVideoBound = 'true';

    var video = wrapper.querySelector('video');
    if (!video) return;

    if (video.hasAttribute('data-viewport-video')) {
      if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) return;
          videoObserver.disconnect();
          // Give the main product photograph first use of a slow connection.
          // User-initiated playback still starts immediately through toggleSound.
          var productRoot = wrapper.closest('.custom-product');
          var productImage = productRoot && productRoot.querySelector('[js-main-product-slider] img[loading="eager"]');
          if (productImage && !productImage.complete) {
            var startVideo = function () { loadViewportVideo(video); };
            productImage.addEventListener('load', startVideo, { once: true });
            productImage.addEventListener('error', startVideo, { once: true });
          } else {
            loadViewportVideo(video);
          }
        }, { rootMargin: '0px', threshold: 0.5 });
        // Deferred styles and gallery setup can briefly position the video above
        // the fold. Wait for the initial layout before deciding to autoplay.
        if (document.readyState === 'complete') videoObserver.observe(video);
        else window.addEventListener('load', function () { videoObserver.observe(video); }, { once: true });
      } else {
        loadViewportVideo(video);
      }
    }

    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('role', 'button');

    function onToggle(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      toggleSound(wrapper);
    }

    wrapper.addEventListener('click', onToggle);
    video.addEventListener('click', onToggle);

    var hint = wrapper.querySelector('[data-product-metafield-video-hint]');
    if (hint) {
      hint.classList.add('is-muted');
      hint.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        onToggle();
      });
    }

    wrapper.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        toggleSound(wrapper);
      }
    });
  }

  document
    .querySelectorAll('[data-product-metafield-video], [data-collection-metafield-video]')
    .forEach(bindProductMetafieldVideo);
})();

class AoRelatedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('ao-related-products') || html.querySelector('product-recommendations.related-products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (typeof LazyLoad !== 'undefined') {
            try {
              const lazyLoading = new LazyLoad();
              lazyLoading.update();
            } catch (e) {
              console.warn('LazyLoad:', e);
            }
          }

          const sliderEl = this.querySelector('[js-related-product-slider]');
          if (sliderEl && typeof Swiper !== 'undefined') {
            const nextBtn = this.querySelector('.hb-button-next');
            const prevBtn = this.querySelector('.hb-button-prev');
            new Swiper(sliderEl, {
              slidesPerView: 4,
              spaceBetween: 10,
              loop: true,
              navigation: nextBtn && prevBtn ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
              } : false,
              breakpoints: {
                360: {
                  slidesPerView: 2,
                  spaceBetween: 6,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                991: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1360: {
                  slidesPerView: 4
                }
              }
            });
          }

          
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

if (!customElements.get('ao-related-products')) {
  customElements.define('ao-related-products', AoRelatedProducts);
}

// Zip — Autocraze-style "up to 12 months interest free" line
(function initZipInterestFree() {
  var ZIP_INFO_URL = 'https://zip.co/au/how-it-works';

  function openZipInfo(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    window.open(
      ZIP_INFO_URL,
      'zipInterestFree',
      'width=520,height=640,scrollbars=yes,resizable=yes'
    );
  }

  function wireZipRow() {
    var row = document.querySelector('[data-zip-interest-free]');
    if (!row || row.dataset.zipWired === 'true') return;
    row.dataset.zipWired = 'true';

    var line = row.querySelector('.bnpl-zipmsg-line');
    if (!line) return;
    line.addEventListener('click', openZipInfo);
    line.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openZipInfo(event);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireZipRow);
  } else {
    wireZipRow();
  }
})();

// PayPal Pay in 4 messaging
(function initPayPalPayLater() {
  var PAYPAL_INFO_URL = 'https://www.paypal.com/au/webapps/mpp/paypal-payin4';
  var PAYPAL_MESSAGE_STYLE = {
    layout: 'text',
    logo: { type: 'inline' },
    text: { color: 'black', size: 12 }
  };

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getPayPalHost() {
    return document.getElementById('paypal-pay-later-message');
  }

  function openPayPalInfo(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    window.open(
      PAYPAL_INFO_URL,
      'paypalPayIn4',
      'width=520,height=640,scrollbars=yes,resizable=yes'
    );
  }

  function updateCustomLine(priceCents) {
    var installmentEl = document.querySelector('[data-paypal-installment]');
    if (installmentEl && priceCents != null) {
      installmentEl.textContent = formatMoney(Math.round(priceCents / 4));
      var line = installmentEl.closest('.paypal-pay-later-line');
      if (line) line.setAttribute('aria-label', 'Pay in 4 interest-free payments of ' + installmentEl.textContent + ' with PayPal');
    }
  }

  function syncHiddenSdk(amount) {
    var el = getPayPalHost();
    if (!el) return;
    el.setAttribute('data-pp-amount', amount);
    if (typeof paypal === 'undefined' || !paypal.Messages) return;
    el.innerHTML = '';
    paypal.Messages({
      amount: parseFloat(amount),
      pageType: 'product-details',
      style: PAYPAL_MESSAGE_STYLE
    }).render(el);
  }

  function wirePayPalRow() {
    var wrapper = document.querySelector('[data-paypal-pay-later]');
    if (!wrapper || wrapper.dataset.paypalWired === 'true') return;
    wrapper.dataset.paypalWired = 'true';

    var line = wrapper.querySelector('.paypal-pay-later-line');
    if (line) {
      line.addEventListener('click', openPayPalInfo);
      line.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          openPayPalInfo(event);
        }
      });
    }
  }

  window.updatePayPalPayLaterAmount = function (priceCents) {
    if (priceCents == null) return;
    var amount = (priceCents / 100).toFixed(2);
    updateCustomLine(priceCents);
    syncHiddenSdk(amount);
    var wrapper = document.querySelector('[data-paypal-pay-later]');
    if (wrapper) wrapper.setAttribute('data-amount', amount);
  };

  function initPayPalPayLaterUi() {
    wirePayPalRow();
    var wrapper = document.querySelector('[data-paypal-pay-later]');
    var host = getPayPalHost();
    if (wrapper && host && typeof paypal !== 'undefined' && paypal.Messages && host.dataset.paypalSynced !== 'true') {
      host.dataset.paypalSynced = 'true';
      var amount = wrapper.getAttribute('data-amount');
      if (amount) syncHiddenSdk(amount);
    }
  }

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      window.updatePayPalPayLaterAmount(event.detail.variant.price);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPayPalPayLaterUi);
  } else {
    initPayPalPayLaterUi();
  }

  setTimeout(initPayPalPayLaterUi, 500);
  document.addEventListener('aor:payment-messaging-ready', initPayPalPayLaterUi);
})();

/* ------------------------------------------------------------------ *
 * Live price total
 * ------------------------------------------------------------------ *
 * Reflects option / upgrade selections in the PDP price so the
 * customer sees the running total BEFORE add-to-cart. Every selectable
 * choice carries data-og-delta (in cents) — priced option-group cards
 * & dropdowns (snippets/option-groups.liquid) and pack winch/light
 * upgrades (snippets/pack-options.liquid). We sum the selected deltas
 * onto the product base price (data-base-price on the option
 * container) and rewrite [data-product-price] on every change.
 *
 * Bars/packs are single-variant, so the base is fixed and the theme's
 * own variant handler never fires here — no contention over the price
 * element.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var priceEl = document.querySelector('[data-product-price]');
    var containers = document.querySelectorAll('[data-option-groups], [data-pack-options]');
    if (!priceEl || !containers.length) return;

    var baseEl = document.querySelector('[data-base-price]');
    var base = baseEl ? parseInt(baseEl.getAttribute('data-base-price'), 10) : NaN;
    if (!isFinite(base)) return;

    var saveEl = document.querySelector('[data-ao-save-price]');
    var saveDefaultDisplay = saveEl ? saveEl.style.display : '';

    // Compare-at ("was" price) + its preceding "price:" label. Once
    // upgrades push the total above the compare-at, showing a lower
    // strikethrough price is nonsense — hide the whole was-price group
    // while extras are selected, restore it at the base price.
    var compareEl = document.querySelector('[data-compare-price]');
    var compareLabel = compareEl && compareEl.previousElementSibling;
    if (compareLabel && !compareLabel.classList.contains('price-label')) compareLabel = null;
    var compareDefaultDisplay = compareEl ? compareEl.style.display : '';
    var compareLabelDefaultDisplay = compareLabel ? compareLabel.style.display : '';

    function money(cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
      return '$' + (cents / 100).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    function optionsTotal() {
      var sum = 0;
      containers.forEach(function (container) {
        // Radio / checkbox cards — count checked inputs only.
        container.querySelectorAll('input[data-og-delta]').forEach(function (input) {
          if (!input.checked) return;
          var d = parseInt(input.getAttribute('data-og-delta'), 10);
          if (isFinite(d)) sum += d;
        });
        // Dropdown groups — count the selected option.
        container.querySelectorAll('select').forEach(function (select) {
          var opt = select.options[select.selectedIndex];
          if (!opt) return;
          var d = parseInt(opt.getAttribute('data-og-delta'), 10);
          if (isFinite(d)) sum += d;
        });
      });
      return sum;
    }

    function recompute() {
      var extra = optionsTotal();
      priceEl.textContent = money(base + extra);
      // The base compare-at + "you save" badge no longer hold once
      // upgrades push the price up — hide them while extras are selected.
      var hide = extra > 0;
      if (saveEl) saveEl.style.display = hide ? 'none' : saveDefaultDisplay;
      if (compareEl) compareEl.style.display = hide ? 'none' : compareDefaultDisplay;
      if (compareLabel) compareLabel.style.display = hide ? 'none' : compareLabelDefaultDisplay;
      if (window.updatePayPalPayLaterAmount) window.updatePayPalPayLaterAmount(base + extra);
    }

    containers.forEach(function (container) {
      container.addEventListener('change', recompute);
    });

    recompute(); // account for any preselected choices on load
  });
})();

/* ------------------------------------------------------------------ *
 * Option preview callout
 * ------------------------------------------------------------------ *
 * Lets a customer preview the item behind an option (winch, light, bar
 * add-on...) before choosing it: hover the option thumbnail on desktop,
 * or tap the injected zoom badge on touch, to pop a bigger image + the
 * product name as a link (opens the product in a new tab so they don't
 * lose their configuration).
 *
 * Progressive enhancement — each previewable thumbnail is marked in
 * Liquid with:
 *   data-og-pop            (marker)
 *   data-og-pop-img="url"  (thumbnail-sized CDN url; bumped larger here)
 *   data-og-pop-title="…"  (product / item name)
 *   data-og-pop-url="…"    (product url; optional — name is plain text
 *                           when absent)
 * The zoom badge lives inside the option <label> but is a <button>, so
 * clicking it never toggles the radio (interactive descendants are
 * exempt from label activation).
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var triggers = document.querySelectorAll('[data-og-pop]');
    if (!triggers.length) return;

    var callout = document.createElement('div');
    callout.className = 'og-callout';
    callout.setAttribute('role', 'dialog');
    document.body.appendChild(callout);

    var hideTimer = null;
    var current = null;

    function esc(s) {
      return String(s || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    // Stored thumbnails carry a width= param — request a larger render.
    function bigImg(url) {
      if (!url) return '';
      return /([?&]width=)\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1600') : url;
    }

    function fill(trigger) {
      var img = bigImg(trigger.getAttribute('data-og-pop-img'));
      var title = trigger.getAttribute('data-og-pop-title') || '';
      var url = trigger.getAttribute('data-og-pop-url') || '';
      var head = url
        ? '<a class="og-callout__title" href="' + esc(url) + '" target="_blank" rel="noopener">' +
          esc(title) + '</a><span class="og-callout__more">View product details ↗</span>'
        : '<span class="og-callout__title">' + esc(title) + '</span>';
      callout.innerHTML =
        (img ? '<img class="og-callout__img" src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy">' : '') +
        head;
    }

    function position(trigger) {
      var r = trigger.getBoundingClientRect();
      var cw = callout.offsetWidth;
      var ch = callout.offsetHeight;
      var pad = 8;
      var left = r.left + r.width / 2 - cw / 2;
      left = Math.max(pad, Math.min(left, window.innerWidth - cw - pad));
      var top = r.top - ch - pad; // prefer above the thumbnail
      if (top < pad) top = r.bottom + pad; // otherwise below
      top = Math.max(pad, Math.min(top, window.innerHeight - ch - pad));
      callout.style.left = left + 'px';
      callout.style.top = top + 'px';
    }

    function open(trigger) {
      clearTimeout(hideTimer);
      current = trigger;
      fill(trigger);
      callout.classList.add('is-open');
      position(trigger); // after fill so dimensions are known
    }
    function scheduleClose() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(close, 180);
    }
    function close() {
      callout.classList.remove('is-open');
      current = null;
    }

    // Stay open while the pointer is on the callout so the link is reachable.
    callout.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });
    callout.addEventListener('mouseleave', scheduleClose);

    triggers.forEach(function (trigger) {
      // Desktop: hover the thumbnail to preview.
      trigger.addEventListener('mouseenter', function () {
        open(trigger);
      });
      trigger.addEventListener('mouseleave', scheduleClose);

      // Click / tap the image itself (desktop + mobile) to preview. The image
      // is a preview-only zone: preventDefault stops the surrounding <label>
      // from selecting the option, so looking never changes their choice or
      // the price — the rest of the row still selects.
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (current === trigger && callout.classList.contains('is-open')) close();
        else open(trigger);
      });
    });

    document.addEventListener('click', function (e) {
      if (!callout.contains(e.target) && !e.target.closest('[data-og-pop]')) close();
    });
    window.addEventListener('scroll', close, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();
